import { render, staticRenderFns } from "./master-history-paid.vue?vue&type=template&id=640ff11c"
import script from "./master-history-paid.vue?vue&type=script&lang=js"
export * from "./master-history-paid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports